import { hotRanking } from "@/mocks/news";

const trendIcon: Record<string, string> = {
  up: "ri-arrow-up-line",
  down: "ri-arrow-down-line",
  same: "ri-subtract-line",
};

const trendLabel: Record<string, string> = {
  up: "热度上升",
  down: "热度回落",
  same: "热度持平",
};

export default function HotRankingSection() {
  return (
    <section id="ranking" className="w-full bg-foreground-950 py-12 md:py-16">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-8">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-2 text-xs font-medium tracking-wide text-secondary-400">
              <i className="ri-fire-line" aria-hidden />
              热度榜 · 每 3 小时校准
            </span>
            <h2 className="mt-2 font-heading text-2xl font-black text-background-50 md:text-3xl">
              过去 24 小时被讨论最多的八条
            </h2>
          </div>
          <p className="max-w-sm text-xs leading-relaxed text-background-100/60">
            排序依据是阅读量与讨论量的加权值，不包括转发到站外后产生的数据。
          </p>
        </div>

        <ol className="mt-8 grid grid-cols-1 gap-x-10 gap-y-1 lg:grid-cols-2">
          {hotRanking.map((item) => (
            <li key={item.id} className="border-b border-background-50/10">
              <a
                href="#latest"
                className="group flex items-center gap-4 py-4 transition-colors hover:bg-background-50/5"
              >
                <span
                  className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-md font-heading text-lg font-black ${
                    item.rank <= 3
                      ? "bg-primary-500 text-background-50"
                      : "bg-background-50/10 text-background-100"
                  }`}
                >
                  {item.rank}
                </span>
                <span className="min-w-0 flex-1">
                  <span className="block truncate font-heading text-sm font-bold text-background-50 transition-colors group-hover:text-secondary-300 md:text-base">
                    {item.title}
                  </span>
                  <span className="mt-1 flex items-center gap-1 text-xs text-background-100/55">
                    <i className={`${trendIcon[item.trend]} text-sm`} aria-hidden />
                    {trendLabel[item.trend]}
                  </span>
                </span>
                <span className="shrink-0 text-right text-xs text-background-100/70">
                  <span className="block font-heading text-sm font-bold text-secondary-300">
                    {item.heat}
                  </span>
                  讨论热度
                </span>
              </a>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}